var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import { mapState } from 'vuex';
import moment from 'moment';
export default Vue.extend({
    data: function () {
        return {
            status: 0,
            loanOrderId: '',
            dialogVisible: false,
            repayPlanList: [],
            errorMsg: '',
        };
    },
    computed: __assign({}, mapState('loan', ['loanDetail', 'assets'])),
    created: function () {
        this.loanOrderId = this.$route.query.loanOrderId;
        this.$emit('to-loan-launch', {
            status: 1,
        });
        if (this.loanOrderId) {
            this.orderStatus();
        }
        else {
            this.loanDetail.loanStatus = 10;
        }
    },
    methods: {
        closeCurrent: function () {
            this.$router.push({ name: 'orangeLoanOrderList' });
        },
        loanCancle: function () {
            var _this = this;
            this.$confirm('', '', {
                message: "<p class=\"title\">\u60A8\u786E\u5B9A\u8981\u53D6\u6D88\u7528\u6B3E\u7533\u8BF7\u5417\uFF1F</p><p style=\"color:#41485D\">\u8BE5\u64CD\u4F5C\u4E0D\u53EF\u64A4\u56DE\uFF0C\u8BF7\u8C28\u614E\u64CD\u4F5C</p>",
                dangerouslyUseHTMLString: true,
                showClose: false,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
                .then(function () {
                _this.$request({
                    url: '/proxy/oneCar/api/loan/cancel',
                    data: {
                        loanOrderId: _this.loanOrderId,
                    },
                    method: 'post',
                }).then(function (res) {
                    if (!res.errorCode) {
                        _this.$message({
                            message: '取消用款成功!',
                            type: 'success',
                        });
                        _this.loanDetail.loanStatus = 60;
                    }
                    else {
                        _this.loanDetail.loanStatus = 7;
                        _this.errorMsg = res.errorMsg;
                        _this.$message.error('抱歉,操作失败,请重试');
                    }
                });
            })
                .catch(function () { });
        },
        orderStatus: function () {
            var loanOrderId = this.loanOrderId;
            this.$store.dispatch('loan/GET_LOAN_LIST', {
                pageSize: 100,
                loanOrderId: loanOrderId,
            });
        },
        signContract: function () {
            var _this = this;
            var loanOrderId = this.loanOrderId;
            this.$request({
                method: 'post',
                url: '/proxy/oneCar/api/loan/contract/sign/apply',
                data: {
                    loanOrderId: loanOrderId,
                },
            }).then(function (res) {
                if (!res.errorCode) {
                    _this.$message({
                        message: '合同签署申请已发送!',
                        type: 'success',
                    });
                    _this.orderStatus();
                }
                else {
                    _this.$message.error('抱歉,操作失败,请重试');
                }
            });
        },
        showProject: function () {
            this.dialogVisible = true;
            this.getPlan(this.assets[0].assetId);
        },
        getPlanDetail: function (asset, index) {
            this.assets.forEach(function (asset) {
                asset.active = false;
            });
            this.assets[index]['active'] = true;
            this.getPlan(asset);
        },
        getPlan: function (asset) {
            var _this = this;
            var assetId = asset;
            this.$request({
                url: '/proxy/oneCar/api/repay/plan/query',
                data: {
                    assetId: assetId,
                },
                method: 'post',
            }).then(function (res) {
                if (!res.errorCode) {
                    _this.repayPlanList = res.data.repayPlanList;
                }
            });
        },
        toContractDetail: function (url) {
            window.open(url, '_blank');
        },
        formateDate: function (val) {
            return moment(val).format('YYYY-MM-DD');
        },
    },
});
